import React from 'react'
import LgyAlertDialog from 'app/components/util/lgy-alert-dialog/LgyAlertDialog'

const UploadsDisabledMessage = ({ reason }) =>
  <div className='lgy-alert-suspended-readonly'>
    <LgyAlertDialog
      type='info'
      heading={reason}
      text='The assignment details may no longer be modified and no additional appraisals nor sales contracts may be uploaded.' />
  </div>


export default UploadsDisabledMessage